<form class="selection-container" class="height-inherit">
  <div fxLayout="row" class="height-inherit">
    <button
      *ngIf="!open && productItem.available"
      [ngClass]="{ 'button-effect': hasHoverEffect }"
      fxFlex="100%"
      class="lix-raised-button outlined large medium-font"
      mat-raised-button
    >
      <span> + {{ 'add_project.label.add_project_button' | translate }} </span>
    </button>
    <mat-form-field *ngIf="open" appearance="outline" fxFlex="100%">
      <mat-label
        >{{ 'add_project.placeholder.select_project' | translate }}</mat-label
      >
      <input
        type="text"
        aria-label="Assignee"
        matInput
        [formControl]="myControl"
        [matAutocomplete]="auto"
        subscriptSizing="dynamic"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="selectOption($event)"
        (closed)="updateOpen(false)"
        [displayWith]="displayFn"
      >
        <mat-option
          *ngFor="let option of filteredOptions | async"
          [value]="option"
        >
          {{ option.id > -1 ? option.name :
          ('add_project.placeholder.create_project_name' | translate: { name:
          myControl.value || '' }) }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</form>
